module.exports = __webpack_public_path__ + "static/media/Typical Fancy Yarns3.d55f6dde.jpg";